import axios from "axios";
import { apiConfig } from "./authConfig";

const apiClient = axios.create({
  baseURL: apiConfig.baseURL,
});

const decodeJwtPayload = (token) => {
  try {
    const parts = token.split(".");
    if (parts.length < 2) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
};

const logTokenAudienceDebug = (token, endpoint) => {
  if (process.env.NODE_ENV === "production") {
    return;
  }

  const claims = decodeJwtPayload(token);
  if (!claims) {
    return;
  }

  console.info("[API TOKEN DEBUG]", {
    endpoint,
    aud: claims.aud,
    scp: claims.scp,
    azp: claims.azp,
    appid: claims.appid,
    tid: claims.tid,
    iss: claims.iss,
  });
};

const logAudienceOnUnauthorized = (error, token, endpoint) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.message;
  if (status !== 401) {
    return;
  }

  const claims = decodeJwtPayload(token);
  console.error("[API 401 TOKEN DIAGNOSTIC]", {
    endpoint,
    status,
    backendMessage: message,
    aud: claims?.aud,
    scp: claims?.scp,
    azp: claims?.azp,
    appid: claims?.appid,
    tid: claims?.tid,
    iss: claims?.iss,
  });
};


export const fetchClienti = async (token) => {
  try {
    logTokenAudienceDebug(token, apiConfig.endpoints.clienti);
    const response = await apiClient.get(apiConfig.endpoints.clienti, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data?.clienti ?? [];
  } catch (error) {
    logAudienceOnUnauthorized(error, token, apiConfig.endpoints.clienti);
    console.error("Errore nel caricamento dei clienti:", error);
    return [];
  }
};

export const fetchRapportini = async (token, clienteId) => {
  try {
    logTokenAudienceDebug(token, apiConfig.endpoints.rapportini);
    const response = await apiClient.get(apiConfig.endpoints.rapportini, {
      params: { clienteId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    logAudienceOnUnauthorized(error, token, apiConfig.endpoints.rapportini);
    console.error("Errore nel caricamento dei rapportini:", error);
    return { cliente: null, rapportini: [], oreTotali: 0 };
  }
};

export const fetchCommesse = async (token, clienteId) => {
  try {
    logTokenAudienceDebug(token, apiConfig.endpoints.commesse);
    const response = await apiClient.get(apiConfig.endpoints.commesse, {
      params: { clienteId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    logAudienceOnUnauthorized(error, token, apiConfig.endpoints.commesse);
    console.error("Errore nel caricamento delle commesse:", error);
    return [];
  }
};

export default apiClient;
